// APP Logo
export const Logo = 'go';

// HTTP Status
export const OK = 200;
export const CREATED = 201;

// APP Version
export const VERSION = 'v0.1.0';

// Contact Information
export const CONTACT_EMAIL = 'droxgenglobal@gmail.com';

// APP Description
export const APP_DESCRIPTION =
    "Welcome to go-reviews! Search for restaurants across Sri Lanka by province and area. Some features are coming soon. Contact us to add your restaurant or share feedback.";